import { useThemeStore } from "@sentricmusic/ui";
import { useEffect } from "react";

import { useUIStateStore } from "../store/uiStateStore";

/**
 * Custom hook to synchronize TuneCore mode between local UI state and shared theme store.
 * This ensures consistent theme behavior across both local and shared @sentricmusic/ui components.
 *
 * @param {boolean} isTunecore - Whether TuneCore mode should be enabled
 * @param {boolean} isReady - Whether the configuration data is ready (prevents premature sync)
 */
export function useSyncThemeStore(isTunecore, isReady = true) {
  const setIsTunecore = useUIStateStore(state => state.setIsTunecore);
  const setThemeIsTunecore = useThemeStore(state => state.setIsTunecore);

  useEffect(() => {
    if (!isReady) {
      return;
    }

    // Update local UI state store
    setIsTunecore(isTunecore);

    // Sync with shared theme store for @sentricmusic/ui components
    setThemeIsTunecore(isTunecore);
  }, [isTunecore, isReady, setIsTunecore, setThemeIsTunecore]);
}
